export default __webpack_public_path__ + "static/media/copy.3b40f975.svg";